import type {NavigationGuard, RouteRecordRaw} from 'vue-router';

export const sessionGuard: NavigationGuard = () => {
    const allowed = new Set(['development', 'test', 'beta', 'acc']);
    return allowed.has(import.meta.env.MODE) ? true : { name: '404' };
}

export const SessionStartRoute: RouteRecordRaw = {
    path: '/session/start/:sessionId?/:sessionType?',
    name: 'session-start',
    component: () => import('./start.vue'),
    beforeEnter: sessionGuard,
};

export const SessionStartPurchaseRoute: RouteRecordRaw = {
    path: '/session/start/:service',
    name: 'session-start-service',
    component: () => import('./service.vue'),
    beforeEnter: sessionGuard,
};

export const SessionPayRoute: RouteRecordRaw = {
    path: '/session/pay/:sessionId/:sessionType(Payment|TopUp)?',
    name: 'session-pay',
    component: () => import('./pay.vue'),
    beforeEnter: sessionGuard,
};

export default [SessionStartRoute, SessionStartPurchaseRoute, SessionPayRoute];

